import { useEffect } from "react";

import { startDeployVersionCheck } from "@/lib/portal/deploy-version";

/** Reload when a newer deploy version is published (avoids stale SPA bundles for QA). */
export function useDeployVersionCheck(): void {
  useEffect(() => {
    return startDeployVersionCheck();
  }, []);
}
